module.exports = __webpack_public_path__ + "img/انتزاعی.16c6f7bb.png";